import { render, staticRenderFns } from "./MarkerComponentItem.vue?vue&type=template&id=1fda619b&scoped=true"
import script from "./MarkerComponentItem.vue?vue&type=script&lang=js"
export * from "./MarkerComponentItem.vue?vue&type=script&lang=js"
import style0 from "./MarkerComponentItem.vue?vue&type=style&index=0&id=1fda619b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda619b",
  null
  
)

export default component.exports